import React, { useEffect } from "react";
import Meta from "../../components/Meta";
import { requireAuth, useAuth } from "../../util/auth";
import { useTeamMembershipsByMember } from "../../util/db";
import { useRouter } from "../../util/router";
import TeamsSection from "../../components/Custom/TeamsSection";

function TeamsPage(props) {
  const auth = useAuth();
  const router = useRouter();
  const { data: memberships, status } = useTeamMembershipsByMember(auth.user?.uid);
  // Filter out own document - only count as team member if in SOMEONE ELSE's teamMembers
  const isTeamMember = memberships?.some(m => m.id !== auth.user?.uid);

  // Redirect team members to dashboard
  useEffect(() => {
    if (status === "success" && isTeamMember) {
      router.push("/dashboard/dashboard");
    }
  }, [status, isTeamMember, router]);

  // Show nothing while checking membership or redirecting
  if (status === "loading" || (status === "success" && isTeamMember)) {
    return null;
  }

  return (
    <>
      <Meta title="Teams" />
      <TeamsSection/>
    </>
  );
}

export default requireAuth(TeamsPage);
